<template>
    <div>
        <div class="table-responsive">
            <table style="padding: 30px 0 120px;" class="simple_border_table w-full">
                <thead>
                    <tr>
                        <td style="width: 100px;">DAYS</td>
                        <td style="width: 180px;">START TIME</td>
                        <td style="width: 180px;">END TIME</td>
                        <td>BREAKS</td>
                        <td style="width: 150px;">DURATION</td>
                        <!-- <td style="width: 50px;"></td> -->
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(eachData, index) in rearrangeSchedule(schedule)">
                      <tr :class="[!eachData.is_active ? 'disable_tr' : '']" :key="index">
                        <td>
                            <div class="flex items-center">
                                <vs-switch v-model="eachData.is_active" />
                                <span class="inline-block px-4">{{eachData.day}}</span>
                            </div>
                        </td>
                        <td style="width: 150px;">
                            <div style="width: 150px;" class="flatpickr_with_icon">
                                <flat-pickr
                                  v-if="eachData.is_active"
                                  class="w-full"                                                                      
                                  v-model="eachData.start_time"
                                  :config="startConfigdateTimePicker"
                                />
                                <flat-pickr
                                  v-else
                                  class="w-full"                                                                      
                                  v-model="null_time"
                                  :config="startConfigdateTimePicker"
                                />
                                <vs-icon icon-pack="feather" icon="icon-clock"/>
                            </div>
                        </td>
                        <td style="width: 150px;">
                            <div style="width: 150px;" class="flatpickr_with_icon">
                                <flat-pickr
                                  v-if="eachData.is_active"
                                  @change="scheduleChange"
                                    class="w-full"
                                    v-model="eachData.end_time"
                                     :config="{
                                          enableTime: true,
                                          noCalendar: true,
                                          dateFormat: 'H:i',
                                          minTime:eachData.start_time
                                        }"
                                />
                                <flat-pickr
                                  v-else
                                  class="w-full"                                                                      
                                  v-model="null_time"
                                  :config="startConfigdateTimePicker"
                                />
                                <vs-icon icon-pack="feather" icon="icon-clock"/>
                            </div>
                        </td>
                        <td class="relative">
                            <div class="add_break_holder" :class="{ show : active_el == index }">
                                <div class="flex justify-between">
                                    <flat-pickr
                                    v-model="setBreakStart"
                                        class="w-full mx-2"
                                        placeholder="Start Time"
                                        :config="startConfigdateTimePicker"
                                    />
                                    <flat-pickr
                                    v-model="setBreakEnd"
                                        class="w-full mx-2"
                                        placeholder="End Time"
                                        :config="{
                                          enableTime: true,
                                          noCalendar: true,
                                          dateFormat: 'H:i',
                                          minTime:setBreakStart
                                        }"
                                    />
                                </div>
                                <vs-divider />
                                <div class="flex justify-center items-center mt-4">
                                    <vs-button type="border" class="mx-2" @click="closeBreak(index)">Close</vs-button>
                                    <vs-button class="mx-2" @click="addBreaks(index)">Save</vs-button>
                                </div>
                            </div>
                            <div class="flex flex-wrap">
                              <div v-for="(breakTime,indexBrk) in eachData.breaks" :key="indexBrk" class="m-2">
                                <div class="flatpickr_with_icon time_range_holder">
                                  <div class="flatpickr_holder">
                                    <flat-pickr                                      
                                      v-model="breakTime.break_from"
                                      placeholder="Start Time"
                                      :config="startConfigdateTimePicker"
                                    />
                                  </div>
                                  <div class="flatpickr_holder">
                                    <flat-pickr
                                      v-model="breakTime.break_to"
                                      placeholder="End Time"
                                      :config="{
                                          enableTime: true,
                                          noCalendar: true,
                                          dateFormat: 'H:i',
                                          minTime:breakTime.break_from
                                        }"
                                    />                                    
                                  </div>
                                  <vs-icon icon-pack="feather" icon="icon-clock"/>
                                  <div class="removeBreak" @click="removeBreaks(index,indexBrk)">
                                    <vs-icon icon-pack="feather" icon="icon-x"/>
                                  </div>
                                </div>
                              </div>
                              <span style="cursor: pointer;" class="material-icons-outlined" @click="showBreak(index)">add</span>
                            </div>
                            
                        </td>
                        <td>
                          <span v-if="eachData.is_active">{{eachData.start_time.slice(0,-3)}}-{{eachData.end_time.slice(0,-3)}}</span>
                          <span v-else> {{ null_time }}-{{ null_time }}</span>
                        </td>
                        <!-- <td>
                            <vs-dropdown>
                                <vs-button class="btn-drop" type="flat" icon="more_vert"></vs-button>
                                <vs-dropdown-menu>
                                    <vs-dropdown-item>
                                        Edit
                                    </vs-dropdown-item>
                                    <vs-dropdown-item>
                                        Delete
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </td> -->
                      </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <vs-divider />
        <vs-button class="block mx-auto" @click="scheduleChange">Update Settings</vs-button>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import {scheduleTimeApi, fetchScheduleApi } from '@/api/generalapi'

export default {
  data () {
    return {
      customer_id:'',
      active_el: null,
      schedule: [],
      rearrangeSchedules: [],
      setBreakStart:null,
      setBreakEnd:null,
      startConfigdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i'
      },
      null_time: '00:00'
    }
  },
  mounted () {
    this.customer_id = localStorage.getItem('customer_id')
    this.fetchSchedule()
  },
  components: {
    flatPickr
  },
  methods: { 
    rearrangeSchedule (schedules) {
      let days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
      const start_day = JSON.parse(
        localStorage.getItem('localization')
      ).start_day_id
      if (start_day === 0) {
        days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      }
      this.rearrangeSchedules = days.map(day => {
        return schedules.find(ele => {
          if (ele.day === day) {
            return ele
          }
        })
      })
      return this.rearrangeSchedules
    }, 
    async removeBreaks (index, indexBrk) {
      this.schedule[index].breaks.splice(indexBrk, 1)
    },
    async addBreaks (index) {

      const date = '2022-08-22 '
      const newBreakObj = {
        'break_from': new Date(date + this.setBreakStart),
        'break_to': new Date(date + this.setBreakEnd)
      }
      const start_time = new Date(date + this.schedule[index].start_time)
      const end_time = new Date(date + this.schedule[index].end_time)
      let afterBreak = true
      let existBreak = true
      if (start_time.getTime() > newBreakObj.break_from.getTime() || start_time.getTime() > newBreakObj.break_to.getTime() || end_time.getTime() < newBreakObj.break_from.getTime() || end_time.getTime() < newBreakObj.break_to.getTime()) {
        afterBreak = false
        return this.showSuccessMessage('Error', 'Breaks can not be added before start time or after end time', 'danger')
      }

      this.schedule[index].breaks.forEach((ele) => {
       
        const existingBreakObj = {
          'break_from': new Date(date + ele.break_from),
          'break_to': new Date(date + ele.break_to)
        }
        if (
          (
            (existingBreakObj.break_from.getTime() >= newBreakObj.break_from.getTime()) &&
            (newBreakObj.break_to.getTime() >= existingBreakObj.break_from.getTime())
          ) || (
            (newBreakObj.break_from.getTime() >= existingBreakObj.break_from.getTime()) &&
            (existingBreakObj.break_to.getTime() >= newBreakObj.break_to.getTime())
          ) || (
            (newBreakObj.break_from.getTime() <= existingBreakObj.break_to.getTime()) &&
            (newBreakObj.break_to.getTime() >= existingBreakObj.break_to.getTime())
          )
        ) {
          existBreak = false
          return this.showSuccessMessage('Error', 'Duplicate breaks can not be added', 'danger')
        }
      })


      if (existBreak && afterBreak) {
        this.schedule[index].breaks.push({
          break_from:this.setBreakStart,
          break_to:this.setBreakEnd,
          id:null
        })
      } 
      

      this.active_el = null
      this.setBreakStart = null
      this.setBreakEnd = null
      
    },
    fetchSchedule () {
      fetchScheduleApi(this.customer_id)
      .then(data => {
        this.schedule = data.data.data.fetchUserScheduleSetting
        }
      );
    },
    async scheduleChange () {
      const availabilty = this.schedule.map((ele) => {
        fetchScheduleApi
        return {
          ...ele,
          start_time : ele.start_time.length < 6 ?  `${ele.start_time}:00` : ele.start_time,
          end_time : ele.end_time.length < 6 ? `${ele.end_time}:00` : ele.end_time,
          breaks: ele.breaks.length > 0 ? ele.breaks.map((item) => {
            console.log(item)
            return {
              ...item,
              break_from : item.break_from.length < 6 ?  `${item.break_from}:00` : item.break_from,
              break_to : item.break_to.length < 6 ? `${item.break_to}:00` : item.break_to
            }
          }) : ele.breaks
            
        }
      })
      const payload = {
        updateField:{
          customer_id:this.customer,
          schedule:availabilty
        }
      }
      const data = await scheduleTimeApi(this.customer_id, payload)
      this.showSuccessMessage('Success', 'Schedule updated Successfully', 'success')
      console.log(data)
    },
    showBreak (id) {
      this.active_el = id
    },
    closeBreak () {
      this.active_el = null
    }
  }
}
</script>